<template>
    <div>
        <app-finalizacao
            :finalizacao="finalizacao"
            :finalizacoesServicos="obterFinalizacoesServicos()"
            :movimentosServicos="obterMovimentosServicos()"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
            v-show="mostrarFinalizacao"
        >
            <template slot="entregaAcoes" slot-scope="data">
                <span class="text-primary">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
        </app-finalizacao>
        <router-view></router-view>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import MovimentosServicos from './../movimentos/MovimentosServicos'
import Finalizacao from '@/app/credenciados/componentes/finalizacoes/Finalizacao'

export default {
    data() {
        return {
            finalizacao: {}
        }
    },

    methods: {
        obterFinalizacao() {
            this.$store.dispatch('addRequest')
            FinalizacoesServicos.obterPorId(
                this.$route.params.finalizacaoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacao = response.data
                    } else {
                        this.$toast.error(
                            'Não foi possível obter a finalização.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFinalizacoesServicos() {
            return FinalizacoesServicos
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Uabs_Finalizacoes_Entrega',
                params: {
                    entregaId: entregaId
                }
            })
        },

        obterFinalizacaoAtualizada() {
            this.obterFinalizacao()
            this.$store.dispatch('setRecarregar', true)
        },

        obterMovimentosServicos() {
            return MovimentosServicos
        }
    },

    computed: {
        mostrarFinalizacao() {
            return this.$route.name == 'Uabs_Finalizacoes_Detalhar'
        }
    },

    components: {
        AppFinalizacao: Finalizacao
    },

    created() {
        this.obterFinalizacao()
    }
}
</script>
